/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { rfqQuoteDetailsPageContainerStyles } from "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsPageContainer";
import { css } from "styled-components";

rfqQuoteDetailsPageContainerStyles.mainContainer = {
    gap: 30,
};

rfqQuoteDetailsPageContainerStyles.leftColumnGridItem = {
    width: 12,
};

rfqQuoteDetailsPageContainerStyles.leftColumnInnerContainer = {
    gap: 30,
};

rfqQuoteDetailsPageContainerStyles.rigthColumnGridItem = {
    width: [12, 8, 6, 5, 4],
    css: css`
        &&& {
            display: none;
        }
    `,
};
